import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchDataRoomSetupDocumentsThunk } from "@dataRoomSetup/store/fetchDataRoomSetupDocumentThunk";
import { getDataRoomItemKey } from "@dataRoomSetup/utils/dataRoomItemKey";
import { DocumentResponse } from "@documents/models/api.models";

interface InitialDocumentsState {
  setupDocument: DocumentResponse[];
  loading: boolean;
  error: string | null;
}

const initialState: InitialDocumentsState = {
  setupDocument: [],
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "initialDocuments",
  initialState,
  reducers: {
    updateDocumentsFolderPath(state, action: PayloadAction<{ itemKeys: string[]; newFolderPath: string }>) {
      const { itemKeys, newFolderPath } = action.payload;
      const keySet = new Set(itemKeys);

      state.setupDocument = state.setupDocument.map((doc) =>
        keySet.has(getDataRoomItemKey(doc)) ? { ...doc, folderPath: newFolderPath } : doc
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataRoomSetupDocumentsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDataRoomSetupDocumentsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.setupDocument = action.payload;
      })
      .addCase(fetchDataRoomSetupDocumentsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch folders";
      });
  },
});

export const { updateDocumentsFolderPath } = slice.actions;

export default slice.reducer;
